import React from "react";
import { RiShareBoxLine } from "react-icons/ri";

const Footer = () => {
  return (
    <footer className="w-full bg-white px-5 py-3 fixed bottom-0 z-[40]">
      <div className="flex flex-col xss:flex-row xss:items-center justify-between gap-2 xss:gap-6">
        {/* Logo Section */}

        <a
          href="https://noorahealth.org/"
          target="_blank"
          rel="noreferrer"
          className="cursor-pointer"
        >
          <img
            src="/assets/img/noora-logo.png"
            alt="Noora Health"
            className="object-contain w-[120px] h-[40px]"
          />
        </a>

        {/* Back Link Section */}
        <div className="flex items-center justify-center">
          <a
            // href="https://noorahealth.org/"
            // target="_blank"
            // rel="noreferrer"
            className="flex items-center gap-2 text-softBlack font-medium"
          >
            <RiShareBoxLine size={20} />
            <span className="text-base">Back to Caregiving Page</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
